import { useCallback, useEffect, useState } from 'react';

export const useInlineSvgFromUrl = (url) => {
  const [svgContent, setSvgContent] = useState('');

  const fetchSvg = useCallback(async () => {
    try {
      const response = await fetch(url);

      if (!response.ok)
        throw new Error(`Error ${response.status}: ${response.statusText}`);

      const svgContent = await response.text();

      setSvgContent(svgContent);
    } catch (e) {
      console.error('Failed to fetch svg:', e);
      setSvgContent('');
    }
  }, [url]);

  useEffect(() => {
    url && fetchSvg();
  }, [url]);

  return svgContent;
};
